import { render, staticRenderFns } from "./ConfigPrizeSetting.vue?vue&type=template&id=70604660&scoped=true"
import script from "./ConfigPrizeSetting.vue?vue&type=script&lang=ts"
export * from "./ConfigPrizeSetting.vue?vue&type=script&lang=ts"
import style0 from "./ConfigPrizeSetting.vue?vue&type=style&index=0&id=70604660&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70604660",
  null
  
)

export default component.exports